import { render, staticRenderFns } from "./welcome-website.vue?vue&type=template&id=0eb6a6e4&scoped=true&"
import script from "./welcome-website.vue?vue&type=script&lang=js&"
export * from "./welcome-website.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb6a6e4",
  null
  
)

export default component.exports